import { useTheme } from "../contexts/ThemeContext";
import { Sun, Moon, ShieldCheck } from "./icons";

interface Props {
  loState?: string | null;
  loLicense?: string | null;
}

export default function Topbar({ loState, loLicense }: Props) {
  const { theme, toggle } = useTheme();

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <div className="brand">
          {/* Brand mark: prefers /brand-logo.svg (the VA Loan Educator eagle).
              Falls back to /favicon.svg if the brand logo file is missing so
              the header never renders broken. */}
          <img
            className="brand__mark"
            src="/brand-logo.svg"
            alt=""
            aria-hidden="true"
            width={36}
            height={36}
            onError={(e) => {
              const img = e.currentTarget;
              if (img.src.endsWith("brand-logo.svg")) img.src = "/brand-logo.png";
              else if (img.src.endsWith("brand-logo.png")) img.src = "/favicon.svg";
            }}
          />
          <div className="brand__text">
            <div className="brand__name">VA Loan Educator</div>
            <div className="brand__sub">Talk with your loan officer</div>
          </div>
        </div>

        <div className="topbar__right">
          {(loState || loLicense) && (
            <div className="trust" aria-label="Trust details">
              <ShieldCheck className="trust__icon" />
              {loLicense && <span className="trust__item">NMLS #{loLicense}</span>}
              {loLicense && loState && <span className="trust__sep" />}
              {loState && <span className="trust__item">Licensed in {loState}</span>}
            </div>
          )}
          <button
            className="icon-btn"
            onClick={toggle}
            title={theme === "dark" ? "Switch to light" : "Switch to dark"}
            aria-label="Toggle color theme"
          >
            {theme === "dark" ? <Sun /> : <Moon />}
          </button>
        </div>
      </div>
    </header>
  );
}
